'use strict';

var cov_1sbrag3he0 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.config.js',
        hash = '65dc2a867844b616f8c5354c69b92602370b8775',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 51
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 52
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1sbrag3he0.s[0]++;
(function () {
    'use strict';

    cov_1sbrag3he0.f[0]++;
    cov_1sbrag3he0.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config($authProvider, AppSettings) {
        cov_1sbrag3he0.f[1]++;
        cov_1sbrag3he0.s[2]++;

        $authProvider.baseUrl = AppSettings.apiUrl;

        cov_1sbrag3he0.s[3]++;
        $authProvider.loginUrl = '/api-token-auth/';

        cov_1sbrag3he0.s[4]++;
        $authProvider.facebook({
            clientId: AppSettings.facebookAppId,
            url: '/auth/facebook/'
        });
    }
})();